import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import type { Database } from "../../lib/database.types";
import { formatRiyadhDate } from "../../lib/format";
import { supabase } from "../../lib/supabase";
import { AppIcon } from "../shell/AppIcon";

type Notification = Pick<Database["public"]["Tables"]["notifications"]["Row"], "id" | "notification_type" | "priority" | "title_key" | "body_key" | "entity_type" | "entity_id" | "read_at" | "created_at" | "metadata">;

export function NotificationsInbox() {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage === "en" ? "en" : "ar";
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    await supabase.rpc("refresh_my_work_notifications", {});
    const { data } = await supabase.from("notifications").select("id,notification_type,priority,title_key,body_key,entity_type,entity_id,read_at,created_at,metadata").eq("condition_active", true).order("created_at", { ascending: false }).limit(50);
    setItems(data ?? []); setLoading(false);
  }, []);

  useEffect(() => { if (open) void load(); }, [load, open]);
  const unread = items.filter((item) => !item.read_at).length;

  const markRead = async (item: Notification) => {
    if (!item.read_at) await supabase.from("notifications").update({ read_at: new Date().toISOString() }).eq("id", item.id);
    setItems((current) => current.map((row) => row.id === item.id ? { ...row, read_at: row.read_at ?? new Date().toISOString() } : row));
  };

  return <div className="notification-control">
    <button aria-expanded={open} aria-label={t("actions.notifications")} className="icon-button" onClick={() => setOpen((value) => !value)} title={t("actions.notifications")} type="button"><AppIcon name="bell"/>{unread > 0 && <span className="notification-badge">{unread}</span>}</button>
    {open && <aside className="notification-panel" aria-label={t("notifications.inbox")}><header><h2>{t("notifications.inbox")}</h2><button className="link-button" onClick={() => void load()} type="button">{t("notifications.refresh")}</button></header>
      {loading ? <p>{t("actions.loading")}</p> : items.length === 0 ? <p>{t("notifications.empty")}</p> : <div className="notification-list">{items.map((item) => <button className={item.read_at ? "notification-item" : "notification-item unread"} key={item.id} onClick={() => void markRead(item)} type="button"><span className={`status-pill priority-${item.priority}`}>{t(`notificationPriorities.${item.priority}`)}</span><strong>{t(item.title_key)}</strong><span>{t(item.body_key, item.metadata as Record<string, unknown>)}</span><small>{formatRiyadhDate(new Date(item.created_at), locale)}</small></button>)}</div>}
    </aside>}
  </div>;
}
